import { Box, CircularProgress } from '@mui/material'
import EventsEngine from '../../../engines/EventsEngine'
import { useEffect, useState } from 'react'

function StaleIndicator() {
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        const unsub1 = EventsEngine.subscribe('loading-stale-data', 'StaleIndicator', () => {
            setIsLoading(true)
        })
        const unsub2 = EventsEngine.subscribe('loaded-stale-data', 'StaleIndicator', () => {
            setIsLoading(false)
        })
        return () => {
            unsub1()
            unsub2()
        }
    }, [])

    return (
        <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', marginRight: 2 }}>
            {isLoading && <CircularProgress color='inherit' size={25} />}
        </Box>
    )
}

export default StaleIndicator
